import React from 'react';
import {store} from '../../../index';
import App from './createAccountComponent';



export default function(){
    return <App state={store.getState()}></App>;
}